import { useEffect, useState } from "react";
import { navLinks, siteName } from "@/mocks/baoliao";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="bg-accent-500 text-foreground-950 relative">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <div className="md:col-span-4">
            <a href="#top" className="flex items-center gap-2">
              <span className="inline-flex w-9 h-9 items-center justify-center rounded-lg bg-foreground-950 text-background-50 text-base">
                <i className="ri-quill-pen-fill" />
              </span>
              <span className="text-2xl font-bold leading-none" style={{ fontFamily: "var(--font-heading)" }}>
                {siteName}
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-800 max-w-sm">
              专注一手消息与独家猛料，覆盖内部流出、首发曝光、绝密文件等核心内容，陪你一起逼近事件真相。
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="text-sm font-medium">一手消息 · 先人一步</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-bold tracking-wide">快速导航</h4>
            <ul className="mt-3 flex flex-col gap-2 text-sm">
              {navLinks.map((l) => (
                <li key={l.key}>
                  <a href={l.href} className="text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-bold tracking-wide">爆料栏目</h4>
            <ul className="mt-3 flex flex-col gap-2 text-sm">
              <li><a href="#feed" className="text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap">内部流出</a></li>
              <li><a href="#exclusive" className="text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap">首发曝光</a></li>
              <li><a href="#exclusive" className="text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap">绝密文件</a></li>
              <li><a href="#feed" className="text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap">圈内传闻</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-bold tracking-wide">联系我们</h4>
            <ul className="mt-3 flex flex-col gap-2 text-sm">
              <li><a href="#tip" className="text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap">我要爆料</a></li>
              <li><a href="mailto:hello@guaguabaoliao.com" className="text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap">hello@guaguabaoliao.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-5 border-t border-foreground-900/20 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-700">© {new Date().getFullYear()} {siteName} · 本站内容均为娱乐资讯与吃瓜栏目示例，仅用于信息展示。</p>
          <div className="flex items-center gap-3 text-foreground-800">
            <a href="#top" className="hover:text-foreground-950" aria-label="返回顶部"><i className="ri-arrow-up-line" /></a>
            <a href="#tip" className="hover:text-foreground-950" aria-label="投稿"><i className="ri-megaphone-line" /></a>
            <a href="#faq" className="hover:text-foreground-950" aria-label="常见问题"><i className="ri-question-line" /></a>
          </div>
        </div>
      </div>

      {/* 回顶按钮 */}
      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 inline-flex w-11 h-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-primary-600 transition-colors shadow-none animate-rise-in"
        >
          <i className="ri-arrow-up-line text-lg" />
        </a>
      )}
    </footer>
  );
}